import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  changeAddressCity,
  changeAddressFirstName,
  changeAddressLastName,
  changeAddressState,
  changeAddressZip,
  changeFlag
} from 'Agent/Policies/ducks/policyServiceRequest';
import {AddressChangeRequest} from 'Agent/Policies/models/ServiceRequest/AddressChangeRequest';
import {Empty} from 'Core/models/Async';
import './AddressChangeRequest.sass';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {
  addressIsChanged,
  addressSelection,
  changeUnValidatedAddressAccepted,
  changeValidateAddress,
  isAddressValidated,
  RequiredCheckoutCartFields,
  selectAddress,
  setAddress,
  StateFilter,
  validateAddress,
} from '../ducks/policyServiceRequest';

export type AddressChangeRequestProps = {
  addressChangeRequest: AddressChangeRequest;
};
export type addressType = React.Dispatch<React.SetStateAction<AddressChangeRequest>>;

const AddressChangeRequestForm = (props: AddressChangeRequestProps) => {
  const {addressValidationResponse, unValidatedAddressAccepted, missingRequiredFields, flag} = useSelector(
    (state: ReducerState) => state.policyServiceRequest
  );
  const dispatch = useDispatch();
  const {addressChangeRequest} = props;

  const [addressChangeRequestCopy, setaddressChangeRequestCopy] = useState<AddressChangeRequest>({
    ...addressChangeRequest,
  });
  const [addressConfirmed, setAddressConfirmed] = useState(false);

  useEffect(() => {
    dispatch(changeValidateAddress(new Empty()));
  }, []);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      dispatchChange();
    }
  }, [addressChangeRequestCopy.address]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      let zip = addressChangeRequestCopy.zip;
      if (zip?.length === 5 || zip?.length === 10) {
        dispatchChange();
      }
    }
  }, [addressChangeRequestCopy.zip]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      const delayDebounceFn = setTimeout(() => {
        dispatchChange();
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [addressChangeRequestCopy.city]);

  useEffect(() => {
    if (!unValidatedAddressAccepted) {
      dispatchChange();
    }
  }, [addressChangeRequestCopy.state]);

  function dispatchChange() {
    if (addressIsChanged(addressChangeRequestCopy, addressValidationResponse)) {
      if (
        addressChangeRequestCopy.address !== '' &&
        (addressChangeRequestCopy.zip !== '' ||
          (addressChangeRequestCopy.city !== '' && addressChangeRequestCopy.state !== ''))
      ) {
        dispatch(validateAddress(addressChangeRequestCopy, missingRequiredFields));
        setAddressConfirmed(false);
        dispatch(changeUnValidatedAddressAccepted(false));
      }
    }
  }
  return (
    <div className="address-change-request-form">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl className="field-section-account" fullWidth={true}>
            <TextField
              variant="outlined"
              label="Address Line 1"
              placeholder="Address Line 1"
              name="address"
              error={
                missingRequiredFields.includes(RequiredCheckoutCartFields.ADDRESS_LINE_1) &&
                addressChangeRequestCopy.address === ''
              }
              value={addressChangeRequestCopy.address}
              onChange={e => {
                dispatch(changeAddressFirstName(e.target.value));
                dispatch(changeUnValidatedAddressAccepted(false));
                setAddress(e, setaddressChangeRequestCopy, addressChangeRequestCopy);
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className="field-section-account address-line-2-form-control" fullWidth={true}>
            <TextField
              variant="outlined"
              label="Address Line 2"
              placeholder="Address 2"
              name="address2"
              value={addressChangeRequestCopy.address2}
              onChange={e => {
                dispatch(changeAddressLastName(e.target.value));
                setAddress(e, setaddressChangeRequestCopy, addressChangeRequestCopy);
              }}
            />
          </FormControl>
        </Grid>
        <Grid container spacing={2} className="address-grid-container">
          <Grid item xs={4}>
            <FormControl className="flex-item-right form-field-full-width">
              <TextField
                variant="outlined"
                label={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.CITY) &&
                  addressChangeRequestCopy.city === ''
                    ? 'City is required'
                    : 'City'
                }
                placeholder="City"
                name="city"
                error={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.CITY) &&
                  addressChangeRequestCopy.city === ''
                }
                value={addressChangeRequestCopy.city}
                onChange={e => {
                  dispatch(changeAddressCity(e.target.value));
                  dispatch(changeUnValidatedAddressAccepted(false));
                  setAddress(e, setaddressChangeRequestCopy, addressChangeRequestCopy);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className="form-field-full-width">
              <InputLabel variant="outlined" htmlFor="uncontrolled-native">
                State
              </InputLabel>
              <Select
                variant="outlined"
                label={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.STATE) &&
                  addressChangeRequestCopy.state === ''
                    ? 'State is required'
                    : 'State'
                }
                placeholder="State"
                name="state"
                error={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.STATE) &&
                  addressChangeRequestCopy.state === ''
                }
                value={addressChangeRequestCopy.state}
                onChange={e => {
                  dispatch(changeAddressState(e.target.value));
                  dispatch(changeUnValidatedAddressAccepted(false));
                  setAddress(e, setaddressChangeRequestCopy, addressChangeRequestCopy);
                }}
                inputProps={{
                  name: 'state',
                  id: 'uncontrolled-native',
                }}
              >
                <MenuItem value="" disabled selected>
                  Select State
                </MenuItem>
                {StateFilter.map(state => (
                  <MenuItem key={state.value} value={state.value}>
                    {state.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl className="flex-item-left form-field-full-width">
              <TextField
                variant="outlined"
                label={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.ZIP) && addressChangeRequestCopy.zip === ''
                    ? 'Zip is required'
                    : 'Zip'
                }
                placeholder="Zip Code"
                name="zip"
                error={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.ZIP) && addressChangeRequestCopy.zip === ''
                }
                value={addressChangeRequestCopy.zip}
                onChange={e => {
                  dispatch(changeAddressZip(e.target.value));
                  dispatch(changeUnValidatedAddressAccepted(false));
                  setAddress(e, setaddressChangeRequestCopy, addressChangeRequestCopy);
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid item className="flex-container field-section-formNumber validation-section">
          {addressValidationResponse.key === 'NotFound' &&
          !isAddressValidated(addressValidationResponse) &&
          !unValidatedAddressAccepted ? (
            <FormControl className="field-section-account" fullWidth={true}>
              <Typography align="center" variant="subtitle1" className="validation-message">
                We were unable to validate the address
              </Typography>
              <Button
                className="validation-button"
                color="primary"
                onClick={e => dispatch(changeUnValidatedAddressAccepted(true))}
              >
                Click here to agree to use the address entered above.
              </Button>
            </FormControl>
          ) : (
            isAddressValidated(addressValidationResponse) &&
            !addressConfirmed && (
              <FormControl className="field-section-account" fullWidth={true}>
                <Typography align="center" variant="subtitle1" className="validation-message">
                  Address match found, use this address?
                </Typography>
                <Button
                  className="validation-button"
                  color="primary"
                  variant={addressChangeRequestCopy ? 'text' : 'contained'}
                  onClick={e => {
                    dispatch(changeUnValidatedAddressAccepted(true));
                    dispatch(changeAddressState(addressValidationResponse['Data'].state));
                    dispatch(changeAddressCity(addressValidationResponse['Data'].city));
                    dispatch(changeAddressZip(addressValidationResponse['Data'].zip));
                    dispatch(changeFlag(true));
                    selectAddress(
                      addressValidationResponse,
                      setaddressChangeRequestCopy,
                      addressChangeRequestCopy,
                      setAddressConfirmed
                    );
                  }}
                >
                  {addressSelection(addressValidationResponse)}
                </Button>
                {(flag && !addressConfirmed && addressValidationResponse['Data'].validationMessage.includes("Everything confirmed")) && <Button
                className="validation-button"
                color="primary"
                onClick={e => {
                  dispatch(changeUnValidatedAddressAccepted(true));
                  setAddressConfirmed(true);
                }}
              >
                Click here to agree to use the address entered above.
              </Button>}
              </FormControl>
            )
          )}
        </Grid>
        <Grid container spacing={2} className="info-list-container">
          <Grid item>
            <List className="info-list">
              <ListItem className="info-list-item">
                <ListItemText>Address changes will be applied to all of the policyholder&apos;s policies.</ListItemText>
              </ListItem>
              <ListItem className="info-list-item">
                <ListItemText>
                  Please ensure the employer updates the address of record within the enrollment platform as any
                  subsequent changes made to the policy will override the change submitted.
                </ListItemText>
              </ListItem>
              <ListItem className="info-list-item">
                <ListItemText>
                  Please allow up to 24 hours for all address changes to appear in the system.
                </ListItemText>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddressChangeRequestForm;
